import { Card, CardContent, Stack, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { createRef, useEffect } from 'react'
import { useConfig } from '@kikoda/generated-config-hooks'
import { AppConfig } from 'hooks/useAppConfig'
import { PageWrapper } from 'components/Modules/Wrappers/PageWrapper'

export interface ProviderPaymentProps { }

export const ProviderPayment: React.FC<ProviderPaymentProps> = () => {
  const { state }: any = useLocation()
  const src = useConfig<AppConfig>().additionalConfig?.hppUrl;
  const formRef = createRef<HTMLFormElement>()

  useEffect(() => {
    formRef.current?.submit()
  }, [formRef])
  return (
    <PageWrapper sx={{ paddingX: 0 }}>
      <Stack spacing={2} p={3} alignItems='center'>
        <Card sx={{ width: '100%', maxWidth: 800 }}>
          <CardContent>
            <Typography variant="h6" component='h1' mb={1}>
              Order Details
            </Typography>
            <Stack
              direction="row"
              alignItems="center"
              sx={{ padding: 1, borderBottom: '2px solid', borderColor: 'primary.main', backgroundColor: 'background.default' }}
            >
              <Typography flex={1}>License Number</Typography>
              <Typography flex={1}>Name</Typography>
              <Typography flex={1} textAlign='right'>Amount</Typography>
            </Stack>
            {state.details.map((x: any, i: number) => (
              <Stack
                key={i}
                direction="row"
                alignItems="center"
                sx={{ padding: 1, borderBottom: '1px solid', borderColor: 'primary.light' }}
              >
                <Typography fontSize={14} flex={1}>{x.license}</Typography>
                <Typography fontSize={14} flex={1}>{x.firstName} {x.lastName}</Typography>
                <Typography fontSize={14} flex={1} textAlign='right'>${x.amount}</Typography>
              </Stack>
            ))}
          </CardContent>
        </Card>
        <iframe
          style={{ paddingTop: 1, border: 'none' }}
          id="hpp"
          name="hpp"
          title="hpp"
          width="100%"
          height={800}
        ></iframe>
        <form target="hpp" action={src} method="POST" ref={formRef}>
          <input type="hidden" name="token" value={state.token} />
        </form>
      </Stack>
    </PageWrapper>
  )
}
